import {
  Component,
  Input,
  OnInit,
  AfterViewChecked,
} from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FlowBuilderService } from '../../services/flowBuilder/flow-builder.service';
import { ActiveFormService } from '../../services/active-form.service';
import { regexLibrary } from '../../../../shared/utils/config';
import { NgStyle } from '@angular/common';
@Component({
    selector: 'app-variable',
    templateUrl: './variable.component.html',
    styleUrls: ['./variable.component.scss'],
    animations: [
        trigger('tabState', [
            state('default', style({
                transform: 'translateY(0)',
            })),
            state('open', style({
                transform: 'translate(-245px)',
            })),
            state('close', style({
                right: 'initial',
            })),
            transition('default <=> open', animate(300)),
        ]),
    ],
    imports: [NgStyle]
})
export class VariableComponent implements OnInit, AfterViewChecked {
  variableList: Array<string> = [];
  @Input() topPosition: string;

  constructor(
    public flowBuilderService: FlowBuilderService,
    private activeFormService: ActiveFormService
  ) {}

  state = 'default';
  show = true;
  hidden = false;
  variablesItems = this.flowBuilderService.getVariables;

  regexLibrary = regexLibrary;

  get currentId(): String {
    return this.activeFormService.getStatuses().focus;
  }

  openVariable() {
    this.toggleVariable(true);
  }

  closeVariable() {
    this.toggleVariable(false);
  }

  toggleVariable(status: boolean) {
    this.activeFormService.setMenuOpenStatus(status);
    this.state = this.state === 'default' ? (status ? 'open' : 'close') : 'default';
    this.hidden = !this.hidden;
  }

  copyVarReg(valueToCopy) {
    let element: any = document.getElementById(`${this.activeFormService.getStatuses().focus}`);

    if (this.activeFormService.currentFocusedElement) {
      element = this.activeFormService.currentFocusedElement;
    }

    const position = element.selectionStart;
    const start = element.value.substring(0, position);
    const end = element.value.substring(position, element.value.length);
    const string = start + valueToCopy + end;

    if (this.activeFormService.getActiveForm()) {
      this.activeFormService.setFormValue(string, element.name);
    } else {
      element.value = string;
    }
  }

  ngOnInit() {}

  ngAfterViewChecked() {
    if (this.activeFormService.currentFocusedElement) {
      return;
    }
    const statuses = this.activeFormService.getStatuses();
    const selector =
      statuses.path.indexOf('keywords') === -1
        ? `#${statuses.focus}.dynamicField`
        : `.chip-${statuses.focus}.dynamicField`;
    const element: any = document.querySelector(selector);
    if (!element) {
      this.activeFormService.setMenuOpenStatus(false);
    }
  }
}
